import { useBuildWiseModules } from '@buildwise/libs/helpers';
import { Box, Button, Collapse, Divider, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BUILDWISE_MODULES_FEATURES } from 'components/drawer/constants';
import { useState } from 'react';
import AddLineIcon from 'remixicon-react/AddLineIcon';
import ActivityForm from './ActivityForm';
import RenderActivityLog from './RenderActivityLog';
import Search from '@buildwise/pages/knowledge/components/SearchComponent';

function ActivityLog() {
  const { projectModuleFeatures, singularProjectsModuleName } = useBuildWiseModules();
  const [isAddingNewActivity, setIsAddingNewActivity] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');

  const updateSearch = (value: string) => {
    setSearchKeyword(value.trim());
  };

  return (
    <Container>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography
          component="h3"
          sx={(theme) => ({
            fontWeight: 700,
            fontSize: 18,
            color: theme.palette.custom.tuna,
          })}
        >
          {projectModuleFeatures[BUILDWISE_MODULES_FEATURES.PROJECTS.ACTIVITY_LOG]?.displayName ||
            projectModuleFeatures[BUILDWISE_MODULES_FEATURES.PROJECTS.ACTIVITY_LOG]?.name ||
            'Activity Log'}
        </Typography>
        {!isAddingNewActivity && (
          <Button
            variant="outlined"
            startIcon={<AddLineIcon />}
            onClick={() => setIsAddingNewActivity(true)}
          >
            Add
          </Button>
        )}
      </Box>
      <Typography
        sx={(theme) => ({
          color: theme.palette.custom.mistBlue,
          fontSize: 14,
          mb: 1,
        })}
      >
        Save valuable information specific to this {singularProjectsModuleName.toLowerCase()} for
        future reference.
      </Typography>
      <Divider />
      {!isAddingNewActivity && (
        <Box my={1}>
          <Search
            value={searchKeyword}
            placeholder="Search..."
            setValue={updateSearch}
            filled
            noDebounce
            triggerOnEnter
          />
        </Box>
      )}
      {isAddingNewActivity && <ActivityForm setOpen={setIsAddingNewActivity} />}
      <RenderActivityLog searchKeyword={searchKeyword} />
    </Container>
  );
}

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
  boxShadow: `0 4px 24px ${theme.palette.custom.boxShadow}`,
  borderRadius: 8,
  overflow: 'hidden',
  padding: 16,
}));

export default ActivityLog;
